import type { FaireProductEntity } from "../../entity_types/product";

export const p_utf9dhnz25: FaireProductEntity = {
  token: "p_utf9dhnz25",
  type: "product",
  name: "Dangling Puka Shell Earrings",
  brandName: "Salty But Sweet",
  imageUrl:
    "https://cdn.faire.com/fastly/bdba163293d968540866d0bf23bb5e5728bf876cb8e46919d7c5e3121113942a.jpeg",
  priceDollars: 15.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/ea1637126b5d5ec8bedf3025ae1617817e50b3281d8c8e2ef557fc783b8ba82c.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
